import { render } from "./SlotFooter.vue?vue&type=template&id=4a067438&scoped=true"
import script from "./SlotFooter.vue?vue&type=script&lang=ts"
export * from "./SlotFooter.vue?vue&type=script&lang=ts"

import "./SlotFooter.vue?vue&type=style&index=0&id=4a067438&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4a067438"

export default script